class RequestReturnsDetails {
  constructor(element, options) {
    this._element = element;
    this._options = options;
    this._cacheSelectors();
    this._init();
  }

  _cacheSelectors() {
    this._selectionProducts = this._element.querySelectorAll(
      '.js-request-returns--selection-product'
    );
    this._selectionNextButton = this._element.querySelector(
      '.js-request-returns--selection--next-button'
    );

    this._selectedProducts = this._element.querySelectorAll(
      '.js-request-returns--selected-product'
    );
    this._selectedNextButton = this._element.querySelector(
      '.js-request-returns--selection--next-button'
    );

    this._selectionPanel = this._element.querySelector('.js-request-returns--selection-panel');
    this._selectedPanel = this._element.querySelector('.js-request-returns--selected-panel');
  }

  _init() {
    this._selectionNextButton.disabled = this._disableSelectionNextButton();

    this._selectionProducts.forEach((selectionProduct) => {
      const _selectionProductButton = selectionProduct.querySelector(
        '.js-request-returns--select-product'
      );

      if (_selectionProductButton === null) {
        return false;
      }

      _selectionProductButton.addEventListener('click', (eventSelectionProductButton) => {
        const _currentSelectionProductButton = eventSelectionProductButton.currentTarget;

        if (_currentSelectionProductButton.classList.contains('is-selected')) {
          _currentSelectionProductButton.classList.remove('is-selected');
          selectionProduct.dataset.isSelected = 'false';
        } else {
          _currentSelectionProductButton.classList.add('is-selected');

          selectionProduct.dataset.isSelected = 'true';
        }

        this._selectionNextButton.disabled = this._disableSelectionNextButton();

        if (!this._disableSelectionNextButton()) {
          this._selectionNextButton.addEventListener('click', () => {
            this._selectionPanel.style.display = 'none';
            this._selectedPanel.style.display = 'block';

            this._setSelectedProducts();
          });
        }
      });

      return true;
    });
  }

  _setSelectedProducts() {
    const selectedProducts = this._element.querySelectorAll(
      '.js-request-returns--selected-product'
    );

    const removedProducts = this._selectionPanel.querySelectorAll('[data-is-selected=false]');

    selectedProducts.forEach((selectedProduct) => {
      removedProducts.forEach((removedProduct) => {
        if (selectedProduct.dataset.productId === removedProduct.dataset.productId) {
          selectedProduct.remove();
        }
      });
    });

    this._setRemoveSelectedProducts();
  }

  _disableSelectionNextButton() {
    return this._selectionPanel.querySelectorAll('[data-is-selected=true]').length === 0;
  }

  _setRemoveSelectedProducts() {
    this._selectedProducts.forEach((selectedProduct) => {
      const _removedSelectedProductButton = selectedProduct.querySelector(
        '.js-request-returns--remove-product'
      );

      _removedSelectedProductButton.addEventListener('click', () => {
        selectedProduct.remove();

        this._selectedProducts = this._element.querySelectorAll(
          '.js-request-returns--selected-product'
        );

        if (this._selectedProducts.length === 0) {
          location.reload();
        }
      });
    });
  }
}

export default RequestReturnsDetails;
